import { render, staticRenderFns } from "./color-picker-palette-item.vue?vue&type=template&id=639fabe0&scoped=true&"
import script from "./color-picker-palette-item.vue?vue&type=script&lang=js&"
export * from "./color-picker-palette-item.vue?vue&type=script&lang=js&"
import style0 from "./color-picker-palette-item.vue?vue&type=style&index=0&id=639fabe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639fabe0",
  null
  
)

export default component.exports